import Main from "layout/MainLayout/Main";
import { Home, Detail } from "pages";

const mainRoutes = {
  path: "/",
  element: <Main />,
  children: [
    { path: "/", element: <Home /> },
    { path: "/:category/:slug", element: <Detail /> },
  ],
};

export default mainRoutes;
